export default __webpack_public_path__ + "static/media/RobotoMono-SemiBold.b4c2331d.woff2";